/**
 * Стяжка комнаты на 2D-чертеже — компонент раздела каталога.
 *
 * Косая штриховка цветом своего вида из каталога, полупрозрачная: под ней видна
 * заливка комнаты, а поверх ложится покрытие пола.
 */
import { ScreedMaterial, getScreedMaterial } from "@/shared/catalog";
import type { Room } from "@/widgets/plan";

const makeScreedPatternId = (roomId: string) => `room-screed-${roomId}`;

/**
 * Стяжка комнаты — просто цветная заливка.
 */
export const ScreedShape = ({ room, material }: { room: Room; material: ScreedMaterial }) => {
	const patternId = makeScreedPatternId(room.id);
	const materialInfo = getScreedMaterial(material);

	return (
		<g>
			<defs>
				<pattern
					id={patternId}
					patternUnits="userSpaceOnUse"
					width="8"
					height="8"
					patternTransform="rotate(45)"
				>
					<line x1="0" y1="0" x2="0" y2="8" strokeWidth="2" stroke={materialInfo.color} />
				</pattern>
			</defs>

			<polygon
				points={room.inner.map((p) => `${p.x},${p.y}`).join(" ")}
				fill={`url(#${patternId})`}
				opacity="0.7"
			/>
		</g>
	);
};
